import { useState } from "react";
import { SelectionState, PimsEvent } from "../types";

export function useSelectionState() {
  const [expandedProjects, setExpandedProjects] = useState<Set<string>>(
    new Set()
  );
  const [selectedProjects, setSelectedProjects] = useState<Set<string>>(
    new Set()
  );
  const [selectedSingleEvent, setSelectedSingleEvent] = useState<string>("");
  const [selectedEvents, setSelectedEvents] = useState<Set<string>>(new Set());

  const toggleProjectExpansion = (projectId: string) => {
    const newExpanded = new Set(expandedProjects);
    if (newExpanded.has(projectId)) {
      newExpanded.delete(projectId);
    } else {
      newExpanded.add(projectId);
    }
    setExpandedProjects(newExpanded);
  };

  const handleProjectSelection = (
    projectId: string,
    checked: boolean,
    projectEvents: PimsEvent[]
  ) => {
    const newSelectedProjects = new Set(selectedProjects);
    const newSelectedEvents = new Set(selectedEvents);
    const newExpandedProjects = new Set(expandedProjects);

    if (checked) {
      newSelectedProjects.add(projectId);
      newExpandedProjects.add(projectId);
      // Auto-select all events for this project
      projectEvents.forEach((event) => {
        if (event?.id) {
          newSelectedEvents.add(event.id);
        }
      });
    } else {
      newSelectedProjects.delete(projectId);
      // Deselect all events for this project
      projectEvents.forEach((event) => {
        if (event?.id) {
          newSelectedEvents.delete(event.id);
        }
      });
    }

    setSelectedProjects(newSelectedProjects);
    setSelectedEvents(newSelectedEvents);
    setExpandedProjects(newExpandedProjects);
  };

  const handleEventSelection = (eventId: string, checked: boolean) => {
    const newSelectedEvents = new Set(selectedEvents);

    if (checked) {
      newSelectedEvents.add(eventId);
    } else {
      newSelectedEvents.delete(eventId);
    }

    setSelectedEvents(newSelectedEvents);
  };

  const selectionState: SelectionState = {
    selectedProjects,
    selectedEvents,
    selectedSingleEvent,
    expandedProjects,
  };

  return {
    selectionState,
    setSelectedSingleEvent,
    toggleProjectExpansion,
    handleProjectSelection,
    handleEventSelection,
  };
}
